var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.customFieldDefinition.type.toLowerCase() == "text" ||
      _vm.customFieldDefinition.type.toLowerCase() == "multilinetext"
        ? _c(
            "md-field",
            { class: { "md-invalid": _vm.showError } },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.showLabel ? _vm.fieldLabel : null)),
              ]),
              _vm.customFieldDefinition.type.toLowerCase() == "text"
                ? _c("md-input", {
                    attrs: {
                      placeholder: _vm.placeholder,
                      disabled: _vm.disabled,
                    },
                    on: { blur: _vm.handleBlur },
                    model: {
                      value: _vm.customFieldValue,
                      callback: function ($$v) {
                        _vm.customFieldValue = $$v
                      },
                      expression: "customFieldValue",
                    },
                  })
                : _vm._e(),
              _vm.customFieldDefinition.type.toLowerCase() == "multilinetext"
                ? _c("md-textarea", {
                    attrs: { disabled: _vm.disabled },
                    on: { blur: _vm.handleBlur },
                    model: {
                      value: _vm.customFieldValue,
                      callback: function ($$v) {
                        _vm.customFieldValue = $$v
                      },
                      expression: "customFieldValue",
                    },
                  })
                : _vm._e(),
              _vm.showError
                ? _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.customFieldDefinition.label) + " is required"
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.customFieldDefinition.type.toLowerCase() == "date"
        ? _c(
            "md-field",
            { class: { "md-invalid": _vm.showError } },
            [
              _c(
                "md-datepicker",
                {
                  attrs: {
                    "md-immediately": "",
                    "md-debounce": 10,
                    disabled: _vm.disabled,
                  },
                  on: { "md-closed": _vm.handleBlur },
                  model: {
                    value: _vm.customFieldValue,
                    callback: function ($$v) {
                      _vm.customFieldValue = $$v
                    },
                    expression: "customFieldValue",
                  },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.showLabel ? _vm.fieldLabel : null)),
                  ]),
                ]
              ),
              _vm.showError
                ? _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.customFieldDefinition.label) + " is required"
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.customFieldDefinition.type.toLowerCase() == "checkbox"
        ? _c(
            "md-checkbox",
            {
              attrs: { disabled: _vm.disabled },
              model: {
                value: _vm.customFieldValue,
                callback: function ($$v) {
                  _vm.customFieldValue = $$v
                },
                expression: "customFieldValue",
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.showLabel ? _vm.fieldLabel : "") +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm.customFieldDefinition.type.toLowerCase() === "dropdown"
        ? _c(
            "md-field",
            { class: { "md-invalid": _vm.showError } },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.showLabel ? _vm.fieldLabel : null)),
              ]),
              _c("vue-select", {
                staticClass: "custom-mapping-select",
                attrs: {
                  reduce: function (cf) {
                    return cf.value
                  },
                  label: _vm.showDropdownLabelAs,
                  options: _vm.customFieldDefinition.options,
                  placeholder: _vm.customFieldDefinition.label,
                  searchable: false,
                  disabled: _vm.disabled,
                },
                on: { close: _vm.handleBlur },
                model: {
                  value: _vm.customFieldValue,
                  callback: function ($$v) {
                    _vm.customFieldValue = $$v
                  },
                  expression: "customFieldValue",
                },
              }),
              _vm.showError
                ? _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.customFieldDefinition.label) + " is required"
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.customFieldDefinition.type.toLowerCase() === "radiobutton"
        ? _c("md-field", { class: { "md-invalid": _vm.showError } }, [
            _c("label", { staticClass: "radio-group-label" }, [
              _vm._v(_vm._s(_vm.showLabel ? _vm.fieldLabel : null)),
            ]),
            _c(
              "div",
              { staticClass: "radio-button-group" },
              [
                _vm._l(
                  _vm.customFieldDefinition.options,
                  function (option, index) {
                    return _c(
                      "md-radio",
                      {
                        key: index,
                        attrs: { value: option.value, disabled: _vm.disabled },
                        model: {
                          value: _vm.customFieldValue,
                          callback: function ($$v) {
                            _vm.customFieldValue = $$v
                          },
                          expression: "customFieldValue",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(option.value) +
                            "\n            "
                        ),
                      ]
                    )
                  }
                ),
                !_vm.customFieldDefinition.isRequired &&
                _vm.customFieldValue !== null &&
                _vm.customFieldValue !== undefined &&
                _vm.customFieldValue !== ""
                  ? _c(
                      "md-button",
                      {
                        staticClass:
                          "md-just-icon md-simple radio-clear-button",
                        attrs: {
                          title: "Clear selection",
                          disabled: _vm.disabled,
                        },
                        nativeOn: {
                          click: function ($event) {
                            _vm.customFieldValue = null
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("close")])],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm.showError
              ? _c("span", { staticClass: "md-error" }, [
                  _vm._v(
                    _vm._s(_vm.customFieldDefinition.label) + " is required"
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }